// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auto-refresh-text {\n  font-size: 1.25rem;\n  font-weight: bolder;\n}\n.switch-label:before {\n  display: flex;\n}", ""]);
// Exports
module.exports = exports;
